


const  UtilityService = {
    encrypt(data) {
        try {
            const encoder = new TextEncoder(); // UTF-8
            const bytes = encoder.encode(data);

            let hexString = "";

            for (let b of bytes) {
                let hex = b.toString(16);
                if (hex.length === 1) hex = "0" + hex;
                hexString += hex;
            }

            return hexString;
        } catch (error) {
            console.error("Encryption error:", error);
            return null;
        }
    },

    decrypt(hexString) {
        try {
            const len = hexString.length;
            const bytes = new Uint8Array(len / 2);

            for (let i = 0; i < len; i += 2) {
                bytes[i / 2] =
                    (parseInt(hexString.charAt(i), 16) << 4) +
                    parseInt(hexString.charAt(i + 1), 16);
            }

            const decoder = new TextDecoder("utf-8");
            return decoder.decode(bytes);
        } catch (error) {
            console.error("Decryption error:", error);
            throw error;
        }
    },
};

export default UtilityService;